import 'core-js' // 不清楚哪里无法兼容搜狗等浏览器 全部引入
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import 'moment/locale/zh-cn'
import App from 'App'
import { createRoot } from 'react-dom/client'
import CatchError from './catchError'
import reportWebVitals from './reportWebVitals'
import 'meinian-package/src/antd.less'
import './normalize.less'
import 'meinian-package/src/common.less'
import 'animate.css'

const root = createRoot(document.getElementById('root'))
root.render(<ConfigProvider locale={zhCN}>
  <CatchError><App /></CatchError>
</ConfigProvider>)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log)
